// extracted by mini-css-extract-plugin
export var cardIcon = "_1e-5";
export var cardIconUnframed = "_1e-9";
export var checkboxCard = "_1e-0";
export var checkboxCardSelected = "_1e-4";
export var disabled = "_1e-2";
export var interactive = "_1e-1";
export var outerBorder = "_1e-3";
export var spacerMedium = "_1e-8";
export var spacerSmall = "_1e-7";
export var spacerXsmall = "_1e-6";